/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  width: 100%;
}

[input] {
  position: relative;
}

[icon-name='search'] {
  pointer-events: none;
  position: absolute;
  left: 0;
}

::slotted(input) {
  padding-inline-start: var(--nve-ref-size-800) !important;
}
